import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function ModalMedium() {
  const [show, setShow] = useState(false);
  const { t } = useTranslation('common');

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <Button variant="primary" onClick={handleShow}>
        {t('MODAL_MIDIUM.MODAL_MIDIUMS')}
      </Button>

      <Modal className="custom-modal modal-medium" show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>{t('MODAL_MIDIUM.MODAL_MIDIUMS')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{t('MODAL_MIDIUM.LOREM_MESSAGE')}</p>
          <div className="modal-buttons mt-5 d-flex justify-content-between">
            <button className="btn btn-default"> {t('MODAL_MIDIUM.NO')}</button>
            <button className="btn btn-default"> {t('MODAL_MIDIUM.YES')}</button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ModalMedium;
